import type { StripeProduct } from "@/api/types/paymentGateway";

export function isPackageRecommended(
  product: Pick<StripeProduct, "credits" | "popular">,
  journeyHighlightedCredits: number | null | undefined
): boolean {
  if (journeyHighlightedCredits != null) {
    return journeyHighlightedCredits === product.credits;
  }
  return product.popular;
}

export function findRecommendedPackage(
  mandatoryTotal: number,
  products: readonly Pick<StripeProduct, "credits">[]
): number | null {
  if (products.length === 0) return null;
  const sorted = [...products].sort((a, b) => a.credits - b.credits);
  const match = sorted.find((pkg) => pkg.credits >= mandatoryTotal);
  return match?.credits ?? sorted[sorted.length - 1].credits;
}

export function findRecommendedProduct(
  mandatoryTotal: number,
  products: readonly StripeProduct[]
): StripeProduct | null {
  if (products.length === 0) return null;
  const sorted = [...products].sort((a, b) => a.credits - b.credits);
  const match = sorted.find((pkg) => pkg.credits >= mandatoryTotal);
  return match ?? sorted[sorted.length - 1];
}
